module.exports = __webpack_public_path__ + "img/logo-menu.63674be3.png";